import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { font_families } from "./Styles";
import { Helmet } from "react-helmet";
import { API } from "aws-amplify";
import { RoostButton } from "./Modals";

const myAPI = "Contact";
const otherAPI = "mailchimp";

function Contact() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => setIsChecked(e.target.checked);

  function addEmail() {
    if (email === "") {
      setError("Please enter an email address");
      return;
    }
    if (isChecked) {
      let data = { firstName, lastName, email };
      API.post(otherAPI, "/mailchimp", { body: data })
        .then(() => setError("Thank you for joining the mailing list!"))
        .catch(() => setError("There was an error joining the mailing list"));
    }

    let data = { firstName, lastName, email, subject, description };
    API.post(myAPI, "/Contact", { body: data })
      .then(() => setError("Message Sent"))
      .catch(() => setError("There was an error sending your message"));
  }

  return (
    <div style={{ paddingBottom: 200, backgroundColor: "#f7c9e5", paddingTop: 20,
                fontFamily: "Gotham, sans-serif",
                fontWeight: "lighter", }}>
      <Helmet>
        <title>Contact - roostgame.com</title>
        <meta name="description" content="Contact our team using the form below" />
      </Helmet>
      <div className="container" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            padding: 40,
            maxWidth: 600,
            textAlign: "center",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            alignItems: "center",
            justifyContent: 'center'
          }}
        >
          <h2 style={{ color: "#ed1a84", fontWeight: "bold" }}>Stay Connected</h2>
          <p style={{ fontWeight: "350", color: "#444", fontWeight: "lighter", }}>
            If you need to get in touch, use the form below! If you're a retailer, include your company name and phone number.
          </p>
          <form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <input type="text" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
            <input type="text" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            <input type="email" placeholder="*Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input type="text" placeholder="*Subject" value={subject} onChange={(e) => setSubject(e.target.value)} required />
            <textarea placeholder="*Description" value={description} onChange={(e) => setDescription(e.target.value)} required />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
              <span style={{ paddingLeft: "10px" }}>Sign up for the newsletter?</span>
            </div>
            <p style={{ color: "red" }}>{error}</p>

          </form>
          <div style={{display: 'flex', width: '100%', justifyContent: 'center'}}>
          <RoostButton text="Send Message" action={addEmail} />
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default Contact;
